
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/substrate/extrinsics",
      function () {
        return require("private-next-pages/substrate/extrinsics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/substrate/extrinsics"])
      });
    }
  